import utagLinkGeneric from './utagLinkGeneric';

function trackPixleeActions (eventCategory = 'UGC Widget') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel,
			nonInteraction
		});

	};

}

export default trackPixleeActions;
